import { NotificationOverviewInterface } from '../../..';

export class NotificationOverviewResponseDto implements NotificationOverviewInterface{
  count: number;
  userHasUnseenNotifications: boolean;
}
